"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSchema = exports.userSettingsSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const interests_1 = require("./interests");
const proficiencyLevel_1 = require("./proficiencyLevel");
exports.userSettingsSchema = zod_1.default.object({
    audioSpeed: zod_1.default.number(),
    voiceId: zod_1.default.string(),
    timezone: zod_1.default.string().default("America/Sao_Paulo"),
    conversation: zod_1.default.object({
        immediateFeedback: zod_1.default.boolean(),
    }),
    reminder: zod_1.default.object({
        enabled: zod_1.default.boolean(),
        kind: zod_1.default.enum(["dynamic", "fixed"]),
        types: zod_1.default.object({
            weeklySummary: zod_1.default.boolean(),
            dailyUse: zod_1.default.boolean(),
            finishConversations: zod_1.default.boolean(),
        }),
        hour: zod_1.default
            .enum([
            "00:00",
            "00:30",
            "01:00",
            "01:30",
            "02:00",
            "02:30",
            "03:00",
            "03:30",
            "04:00",
            "04:30",
            "05:00",
            "05:30",
            "06:00",
            "06:30",
            "07:00",
            "07:30",
            "08:00",
            "08:30",
            "09:00",
            "09:30",
            "10:00",
            "10:30",
            "11:00",
            "11:30",
            "12:00",
            "12:30",
            "13:00",
            "13:30",
            "14:00",
            "14:30",
            "15:00",
            "15:30",
            "16:00",
            "16:30",
            "17:00",
            "17:30",
            "18:00",
            "18:30",
            "19:00",
            "19:30",
            "20:00",
            "20:30",
            "21:00",
            "21:30",
            "22:00",
            "22:30",
            "23:00",
            "23:30",
        ])
            .nullable()
            .optional(),
    }),
});
const profileSchema = zod_1.default.object({
    age: zod_1.default.object({
        min: zod_1.default.number(),
        max: zod_1.default.number(),
    }),
    gender: zod_1.default.enum(["male", "female", "other", "preferNotToSay"]),
    profession: zod_1.default.string(),
    motivation: zod_1.default.enum([
        "toTravel",
        "forBusiness",
        "toStudyAbroad",
        "forSelfKnowledge",
        "other",
    ]),
    difficulties: zod_1.default.array(zod_1.default.enum([
        "timeToStudy",
        "disciplineAndConsistency",
        "expandingVocabulary",
        "correctPronunciation",
        "correctGrammar",
        "noOneToPracticeWith",
        "understandingNativeSpeakers",
    ])),
    practiceTimeDailyInMinutes: zod_1.default.number(),
    interests: zod_1.default.array(interests_1.interestSchema),
    filled: zod_1.default.boolean(),
});
exports.userSchema = zod_1.default.object({
    _id: zod_1.default.string(),
    fullName: zod_1.default.string().nullish(),
    firstName: zod_1.default.string().nullish(),
    lastName: zod_1.default.string().nullish(),
    whatsapp: zod_1.default.string(),
    email: zod_1.default.string().email().nullish(),
    proficiencyLevel: proficiencyLevel_1.proficiencyLevelSchema.nullish(),
    proficiencyLevelUpdatedAt: zod_1.default.coerce.date().nullish(),
    // todo:onboarding this needs to be refactored
    onboardingForm: zod_1.default.object({
        difficulties: zod_1.default.array(zod_1.default.string()).nullish(),
        profession: zod_1.default.string().nullish(),
        gender: zod_1.default.string().nullish(),
        age: zod_1.default.string().nullish(),
        fluencyMonthsExpectation: zod_1.default.number().nullish(),
        motivation: zod_1.default.string().nullish(),
    }),
    createdAt: zod_1.default.coerce.date(),
    purchase: zod_1.default.object({
        status: zod_1.default.string(),
    }),
    interestsItems: zod_1.default.array(interests_1.interestItemSchema),
    settings: exports.userSettingsSchema,
    referral: zod_1.default.object({
        link: zod_1.default.string(),
        stats: zod_1.default.object({
            visits: zod_1.default.number(),
            signUps: zod_1.default.number(),
            purchases: zod_1.default.number(),
        }),
    }),
    features: zod_1.default.array(zod_1.default.string()).nullish(),
    profile: profileSchema,
    tester: zod_1.default.boolean().nullish(),
    nativeLanguage: zod_1.default.string(),
});
//# sourceMappingURL=user.js.map